import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableRegisterFidusia } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import LogoPerusahaanSpFidusiaBlackAndWhite from "../../../assets/LogoPerusahaanSpFidusiaBlackAndWhite.jpg";
import { Container, Form, Row, Col, Card } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilRegisterFidusia = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState("");
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  // Data Penjamin
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState(new Date());
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [namaPerusahaanPenjamin, setNamaPerusahaanPenjamin] = useState("");
  const [alamatPerusahaanPenjamin, setAlamatPerusahaanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [lamaKerjaPenjamin, setLamaKerjaPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");
  const [hubunganPenjamin, setHubunganPenjamin] = useState("");

  const [alamatSamaPenjamin, setAlamatSamaPenjamin] = useState(false);
  const [alamatTTPenjamin, setAlamatTTPenjamin] = useState("");
  const [kodeProvinsiTTPenjamin, setKodeProvinsiTTPenjamin] = useState("");
  const [kodeKabupatenTTPenjamin, setKodeKabupatenTTPenjamin] = useState("");
  const [kodeKecamatanTTPenjamin, setKodeKecamatanTTPenjamin] = useState("");
  const [kodeKelurahanTTPenjamin, setKodeKelurahanTTPenjamin] = useState("");
  const [kodePosTTPenjamin, setKodePosTTPenjamin] = useState("");

  const [uangMuka, setUangMuka] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");
  const [pengajuanKredit, setPengajuanKredit] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");

  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [warna, setWarna] = useState("");
  const [nopol, setNopol] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [previewFormulir, setPreviewFormulir] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [registerFidusias, setRegisterFidusias] = useState([]);
  const [registerFidusiasPagination, setRegisterFidusiasPagination] = useState(
    []
  );
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getRegisterFidusiasPagination();
    id && getCustomerById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm]);

  const getRegisterFidusiasPagination = async () => {
    setLoading(true);
    try {
      if (user.tipeUser === "MARKETING") {
        const response = await axios.post(
          `${tempUrl}/registerFidusiasPerCabangKodeMarketingPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            marketingId: user.marketingId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setRegisterFidusiasPagination(response.data.registerFidusias);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      } else {
        const response = await axios.post(
          `${tempUrl}/registerFidusiasPerCabangPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setRegisterFidusiasPagination(response.data.registerFidusias);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getRegisterFidusias = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/registerFidusiasPerCabang`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setRegisterFidusias(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCustomerById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/registerFidusias/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setCif(response.data.customer.cifCustomer);
      setNikCustomer(response.data.customer.nikCustomer);
      setNoKkCustomer(response.data.customer.noKkCustomer);
      setNamaCustomer(response.data.customer.namaCustomer);
      setNamaPanggilanCustomer(response.data.customer.namaPanggilanCustomer);
      setTempatLahirCustomer(response.data.customer.tempatLahirCustomer);
      setTanggalLahirCustomer(
        formatDate(response.data.customer.tanggalLahirCustomer)
      );
      setJenisKelaminCustomer(response.data.customer.jenisKelaminCustomer);
      setAgamaCustomer(response.data.customer.agamaCustomer);
      setNoTeleponCustomer(response.data.customer.noTeleponCustomer);
      setAlamatCustomer(response.data.customer.alamatCustomer);
      setAlamatTTCustomer(response.data.customer.alamatTTCustomer);
      setKodeProvinsi(response.data.customer.provinsis.namaProvinsi);
      setKodeProvinsiTT(response.data.customer.provinsisTT.namaProvinsi);
      setKodeKabupaten(response.data.customer.kabupaten.namaKabupaten);
      setKodeKabupatenTT(response.data.customer.kabupatenTT.namaKabupaten);
      setKodeKecamatan(response.data.customer.kecamatan.namaKecamatan);
      setKodeKecamatanTT(response.data.customer.kecamatanTT.namaKecamatan);
      setKodeKelurahan(response.data.customer.kelurahan.namaKelurahan);
      setKodeKelurahanTT(response.data.customer.kelurahanTT.namaKelurahan);
      setKodePos(response.data.customer.kelurahan.kodePos);
      setKodePosTT(response.data.customer.kelurahanTT.kodePos);
      setStatusPerkawinanCustomer(
        response.data.customer.statusPerkawinanCustomer
      );
      setPekerjaanCustomer(response.data.customer.pekerjaanCustomer);
      setKewarganegaraanCustomer(
        response.data.customer.kewarganegaraanCustomer
      );

      setNamaPerusahaanCustomer(response.data.customer.namaPerusahaanCustomer);
      setBidangUsahaCustomer(response.data.customer.bidangUsahaCustomer);
      setJabatanCustomer(response.data.customer.jabatanCustomer);
      setAlamatPerusahaanCustomer(
        response.data.customer.alamatPerusahaanCustomer
      );
      setNoTeleponPerusahaanCustomer(
        response.data.customer.noTeleponPerusahaanCustomer
      );
      setLamaKerjaCustomer(response.data.customer.lamaKerjaCustomer);
      setGajiPekerjaanCustomer(response.data.customer.gajiPekerjaanCustomer);
      setPendapatanLainCustomer(response.data.customer.pendapatanLainCustomer);

      setNikPenjamin(response.data.nikPenjamin);
      setNoKkPenjamin(response.data.noKkPenjamin);
      setNamaPenjamin(response.data.namaPenjamin);
      setTempatLahirPenjamin(response.data.tempatLahirPenjamin);
      setTanggalLahirPenjamin(
        response.data.tanggalLahirPenjamin &&
          formatDate(response.data.tanggalLahirPenjamin)
      );
      setJenisKelaminPenjamin(response.data.jenisKelaminPenjamin);
      setAgamaPenjamin(response.data.agamaPenjamin);
      setNoTeleponPenjamin(response.data.noTeleponPenjamin);
      setAlamatPenjamin(response.data.alamatPenjamin);
      setKodeProvinsiPenjamin(
        response.data.provinsisPenjamin &&
          response.data.provinsisPenjamin.namaProvinsi
      );
      setKodeKabupatenPenjamin(
        response.data.kabupatenPenjamin &&
          response.data.kabupatenPenjamin.namaKabupaten
      );
      setKodeKecamatanPenjamin(
        response.data.kecamatanPenjamin &&
          response.data.kecamatanPenjamin.namaKecamatan
      );
      setKodeKelurahanPenjamin(
        response.data.kelurahanPenjamin &&
          response.data.kelurahanPenjamin.namaKelurahan
      );
      setKodePosPenjamin(
        response.data.kelurahanPenjamin &&
          response.data.kelurahanPenjamin.kodePos
      );
      setStatusPerkawinanPenjamin(response.data.statusPerkawinanPenjamin);
      setNamaPerusahaanPenjamin(response.data.namaPerusahaanPenjamin);
      setAlamatPerusahaanPenjamin(response.data.alamatPerusahaanPenjamin);
      setPekerjaanPenjamin(response.data.pekerjaanPenjamin);
      setLamaKerjaPenjamin(response.data.lamaKerjaPenjamin);
      setKewarganegaraanPenjamin(response.data.kewarganegaraanPenjamin);
      setHubunganPenjamin(response.data.hubunganPenjamin);

      setAlamatSamaPenjamin(response.data.alamatSamaPenjamin);
      setAlamatTTPenjamin(response.data.alamatTTPenjamin);
      setKodeProvinsiTTPenjamin(
        response.data.provinsisTTPenjamin &&
          response.data.provinsisTTPenjamin.namaProvinsi
      );
      setKodeKabupatenTTPenjamin(
        response.data.kabupatenTTPenjamin &&
          response.data.kabupatenTTPenjamin.namaKabupaten
      );
      setKodeKecamatanTTPenjamin(
        response.data.kecamatanTTPenjamin &&
          response.data.kecamatanTTPenjamin.namaKecamatan
      );
      setKodeKelurahanTTPenjamin(
        response.data.kelurahanTTPenjamin &&
          response.data.kelurahanTTPenjamin.namaKelurahan
      );
      setKodePosTTPenjamin(
        response.data.kelurahanTTPenjamin &&
          response.data.kelurahanTTPenjamin.kodePos
      );

      setUangMuka(response.data.uangMuka);
      setPinjamanAju(response.data.pinjamanAju);
      setAngPerBulan(response.data.angPerBulan);
      setTenor(response.data.tenor);
      setPengajuanKredit(response.data.pengajuanKredit);
      setKodeMarketing(
        response.data.marketing
          ? `${response.data.marketing.kodeMarketing} - ${response.data.marketing.namaMarketing}`
          : ""
      );

      setMerk(response.data.merk);
      setTipe(response.data.tipe);
      setTahun(response.data.tahun);
      setWarna(response.data.warna);
      setNopol(response.data.nopol);
      setKeterangan(response.data.keterangan);
    }
  };

  const deleteRegisterFidusia = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteRegisterFidusia/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setNikCustomer("");
      setNoKkCustomer("");
      setCif("");
      setNamaCustomer("");
      setNamaPanggilanCustomer("");
      setTempatLahirCustomer("");
      setTanggalLahirCustomer("");
      setJenisKelaminCustomer("");
      setAgamaCustomer("");
      setNoTeleponCustomer("");
      setAlamatCustomer("");
      setKodeProvinsi("");
      setKodeKabupaten("");
      setKodeKecamatan("");
      setKodeKelurahan("");
      setKodePos("");
      setStatusPerkawinanCustomer("");
      setPekerjaanCustomer("");
      setKewarganegaraanCustomer("");

      setNamaPerusahaanCustomer("");
      setBidangUsahaCustomer("");
      setJabatanCustomer("");
      setAlamatPerusahaanCustomer("");
      setNoTeleponPerusahaanCustomer("");
      setLamaKerjaCustomer("");
      setGajiPekerjaanCustomer("");
      setPendapatanLainCustomer("");

      setNikPenjamin("");
      setNoKkPenjamin("");
      setNamaPenjamin("");
      setTempatLahirPenjamin("");
      setTanggalLahirPenjamin("");
      setJenisKelaminPenjamin("");
      setAgamaPenjamin("");
      setNoTeleponPenjamin("");
      setAlamatPenjamin("");
      setKodeProvinsiPenjamin("");
      setKodeKabupatenPenjamin("");
      setKodeKecamatanPenjamin("");
      setKodeKelurahanPenjamin("");
      setKodePosPenjamin("");
      setStatusPerkawinanPenjamin("");
      setNamaPerusahaanPenjamin("");
      setAlamatPerusahaanPenjamin("");
      setPekerjaanPenjamin("");
      setLamaKerjaPenjamin("");
      setKewarganegaraanPenjamin("");
      setHubunganPenjamin("");

      setAlamatSamaPenjamin("");
      setAlamatTTPenjamin("");
      setKodeProvinsiTTPenjamin("");
      setKodeKabupatenTTPenjamin("");
      setKodeKecamatanTTPenjamin("");
      setKodeKelurahanTTPenjamin("");
      setKodePosTTPenjamin("");

      setUangMuka("");
      setPinjamanAju("");
      setAngPerBulan("");
      setTenor("");
      setPengajuanKredit("");

      setMerk("");
      setTipe("");
      setTahun("");
      setWarna("");
      setNopol("");
      setKeterangan("");
      setPreviewPdf(false);
      setPreviewExcel(false);
      setPreviewFormulir(false);
      navigate("/registerFidusia");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${cif} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Register Fidusia`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Register",
    sheet: "daftarRegister",
  });

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "FormulirRegister",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Register Fidusia</h5>
      {id && (
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/registerFidusia");
              setPreviewPdf(false);
              setPreviewExcel(false);
              setPreviewFormulir(false);
            }}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
        </Box>
      )}
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getRegisterFidusias();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
              setPreviewFormulir(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getRegisterFidusias();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
              setPreviewFormulir(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Nama</th>
                <th>Alamat</th>
                <th>No. Telp</th>
              </tr>
            </thead>
            <tbody>
              {registerFidusias.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.customer.namaCustomer}</td>
                  <td>{user.customer.alamatCustomer}</td>
                  <td>{user.customer.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Nama</th>
                <th>Alamat</th>
                <th>No. Telp</th>
              </tr>
              {registerFidusias.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.customer.namaCustomer}</td>
                  <td>{user.customer.alamatCustomer}</td>
                  <td>{user.customer.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      {id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                // getRegisterFidusias();
                setPreviewFormulir(!previewFormulir);
                setPreviewPdf(false);
                setPreviewExcel(false);
              }}
            >
              Formulir
            </Button>
          </ButtonGroup>
        </Box>
      )}
      {id && previewFormulir && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={generatePDF}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainer}>
            {/* Halaman 1 */}
            <div style={cetakPage}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={LogoPerusahaanSpFidusiaBlackAndWhite}
                  alt="LogoPerusahaanSpFidusiaBlackAndWhite"
                  style={{ width: "400px" }}
                />
              </div>
              <p style={cetakCenter}>FORMULIR REGISTER</p>

              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMOHON</b>
                    </div>
                    <div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Identitas</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Panggilan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Tempat /Tanggal Lahir</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Status</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Jumlah Tanggungan</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat KTP</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaCustomer && namaCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {nikCustomer && nikCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {namaPanggilanCustomer &&
                                  namaPanggilanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {tempatLahirCustomer &&
                                  tempatLahirCustomer.slice(0, 24)}
                                , {tanggalLahirCustomer}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {statusPerkawinanCustomer &&
                                  statusPerkawinanCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatCustomer && alamatCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer && alamatCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatCustomer &&
                            alamatCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Alamat Sekarang</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {alamatTTCustomer &&
                                  alamatTTCustomer.slice(0, 30)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30, 30 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataAlamat}>
                        <p style={textStyle}>
                          {alamatTTCustomer &&
                            alamatTTCustomer.slice(30 + 65, 30 + 65 + 65)}
                        </p>
                      </div>
                      <div style={formulirDataWrapper}>
                        <div style={{ flex: 1 }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 1</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>No. Telp/HP 2</p>
                          </div>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>Nama Gadis Ibu Kandung</p>
                          </div>
                        </div>
                        <div style={{ flex: 1.5 }}>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}>
                                {noTeleponCustomer &&
                                  noTeleponCustomer.slice(0, 36)}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={formulirTextFieldContainer}>
                              <p style={textStyle}>:</p>
                            </div>
                            <div style={formulirTextValueContainer}>
                              <p style={textStyle}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEKERJAAN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Perusahaan/Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bidang Usaha</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Bagian/Jabatan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPerusahaanCustomer &&
                                namaPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {bidangUsahaCustomer &&
                                bidangUsahaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {jabatanCustomer && jabatanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30, 30 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}>
                        {alamatPerusahaanCustomer &&
                          alamatPerusahaanCustomer.slice(30 + 65, 30 + 65 + 65)}
                      </p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp Perusahaan</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Lama Kerja / Status</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {lamaKerjaCustomer &&
                                lamaKerjaCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            height: "104px",
                            border: "1px solid black",
                            paddingTop: "40px",
                          }}
                        >
                          <p style={textStyle}>Besaran Gaji dalam setahun</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"< 50 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"50 Juta - 75 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"75 Juta - 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyleHidden}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <div style={{ display: "flex" }}>
                              <div style={boxStyle}></div>
                              <div>
                                <p style={textStyle}>{"> 100 Juta"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pendapatan Lain</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Atasan Langsung</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Atasan</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {pendapatanLainCustomer.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pekerjaan/Alamat</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPerusahaanCustomer &&
                                noTeleponPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPerusahaanCustomer &&
                                alamatPerusahaanCustomer.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={formulirDataAlamat}>
                      <p style={textStyle}></p>
                    </div>
                  </div>
                </div>

                <div style={{ flex: 1, marginLeft: "20px" }}>
                  <div style={{ border: "1px solid black" }}>
                    <div style={cetakTitle}>
                      <b>DATA KENDARAAN</b>
                    </div>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Merek</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Type</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Tahun</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Warna</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>No. Polisi</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{merk && merk.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tipe && tipe.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{tahun && tahun.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{warna && warna.slice(0, 36)}</p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>{nopol && nopol.slice(0, 36)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}></p>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PEMBIAYAAN / STRUKTUR KREDIT</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Uang Muka</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Pokok Hutang</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Angsuran</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Jangka Waktu</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Sumber Order</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {uangMuka.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {pinjamanAju.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              Rp. {angPerBulan.toLocaleString("de-DE")}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tenor.toLocaleString("de-DE")} BULAN
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {kodeMarketing && kodeMarketing.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid black", marginTop: "20px" }}>
                    <div style={cetakTitle}>
                      <b>DATA PENJAMIN</b>
                    </div>
                    <div style={formulirDataWrapper}>
                      <div style={{ flex: 1 }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Identitas</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Nama Lengkap (Sesuai KTP)</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Tempat /Tanggal Lahir</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>No. Telp/HP</p>
                        </div>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>Alamat Sekarang</p>
                        </div>
                      </div>
                      <div style={{ flex: 1.5 }}>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {nikPenjamin && nikPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {namaPenjamin && namaPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {tempatLahirPenjamin &&
                                tempatLahirPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {noTeleponPenjamin &&
                                noTeleponPenjamin.slice(0, 36)}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={formulirTextFieldContainer}>
                            <p style={textStyle}>:</p>
                          </div>
                          <div style={formulirTextValueContainer}>
                            <p style={textStyle}>
                              {alamatPenjamin && alamatPenjamin.slice(0, 30)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin && alamatPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPenjamin &&
                        alamatPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Nama Perusahaan/Usaha</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Alamat Perusahaan/Usaha</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {namaPerusahaanPenjamin &&
                              namaPerusahaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {alamatPerusahaanPenjamin &&
                              alamatPerusahaanPenjamin.slice(0, 30)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30, 30 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataAlamat}>
                    <p style={textStyle}>
                      {alamatPerusahaanPenjamin &&
                        alamatPerusahaanPenjamin.slice(30 + 65, 30 + 65 + 65)}
                    </p>
                  </div>
                  <div style={formulirDataWrapper}>
                    <div style={{ flex: 1 }}>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Bagian/Jabatan</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Lama Kerja</p>
                      </div>
                      <div style={formulirTextFieldContainer}>
                        <p style={textStyle}>Hubungan Penjamin</p>
                      </div>
                    </div>
                    <div style={{ flex: 1.5 }}>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {pekerjaanPenjamin &&
                              pekerjaanPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {lamaKerjaPenjamin &&
                              lamaKerjaPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={formulirTextFieldContainer}>
                          <p style={textStyle}>:</p>
                        </div>
                        <div style={formulirTextValueContainer}>
                          <p style={textStyle}>
                            {hubunganPenjamin && hubunganPenjamin.slice(0, 36)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div>
                  <div style={cetakTitle}>
                    <b>KETERANGAN LAIN</b>
                  </div>
                </div>
                <div style={{ border: "1px solid black", height: "120px" }}>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(0, 135)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(135, 270)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(270, 405)}
                  </p>
                  <p style={textStyle}>
                    {keterangan && keterangan.slice(405, 540)}
                  </p>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                  <p style={textStyle}>
                    Catatan : Apabila Permohonan sudah disetujui Pemohon dan
                    Penjamin bersedia dan sanggup
                  </p>
                  <div style={{ marginLeft: "80px" }}>
                    <p style={textStyle}>
                      mentaati segala peraturan dan perjanjian yang telah
                      ditetapkan oleh perusahaan
                    </p>
                  </div>
                  <p style={textStyle}>* Coret yang tidak perlu</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/registerFidusia/tambahRegisterFidusia`}
          editLink={`/registerFidusia/${id}/edit`}
          deleteUser={deleteRegisterFidusia}
          nameUser={cif}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            {/* Customer */}
            <Card>
              <Card.Header>Customer</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            CIF :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={cif} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            NIK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={nikCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. KK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noKkCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={namaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Panggilan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={namaPanggilanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tempat Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tempatLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={tanggalLahirCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jenis Kelamin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={jenisKelaminCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Agama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={agamaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noTeleponCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={statusPerkawinanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pekerjaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={pekerjaanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kewarganegaraan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kewarganegaraanCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Alamat (Identitas) */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Alamat (Identitas)</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatan}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupaten}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsi}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePos} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKelurahanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKecamatanTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeKabupatenTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={kodeProvinsiTT}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control value={kodePosTT} disabled readOnly />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Pekerjaan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Pekerjaan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={namaPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Bidang Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={bidangUsahaCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jabatan / Posisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={jabatanCustomer} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={alamatPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No .Telp Perusahaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={noTeleponPerusahaanCustomer}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Lama Kerja / Status :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={lamaKerjaCustomer} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Besaran Gaji / Bulan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={gajiPekerjaanCustomer.toLocaleString(
                                "de-DE"
                              )}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pendapatan Lain :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={pendapatanLainCustomer.toLocaleString(
                                "de-DE"
                              )}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Penjamin */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Penjamin</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            NIK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={nikPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. KK :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noKkPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={namaPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tempat Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tempatLahirPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tgl. Lahir :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tanggalLahirPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Jenis Kelamin :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={jenisKelaminPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Agama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={agamaPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={noTeleponPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Status Perkawinan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={statusPerkawinanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama Perusahaan / Usaha :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={namaPerusahaanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat Perusahaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={alamatPerusahaanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pekerjaan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={pekerjaanPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Lama Kerja / Status :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={lamaKerjaPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kewarganegaraan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kewarganegaraanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Hubungan dengan nasabah :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={hubunganPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Alamat (Identitas) Penjamin */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Alamat (Identitas) Penjamin</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={alamatPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKelurahanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKecamatanPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKabupatenPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeProvinsiPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodePosPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Tempat Tinggal */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Tempat Tinggal</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              disabled
                              value={alamatTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKelurahanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKecamatanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeKabupatenTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={kodeProvinsiTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={kodePosTTPenjamin} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Pinjaman */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Pinjaman</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Uang Muka :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={uangMuka.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pinjaman Rp :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={pinjamanAju.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Ansuran / Bulan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={angPerBulan.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tenor :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled
                              value={tenor.toLocaleString("de-DE")}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Pengajuan kredit :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={pengajuanKredit} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Data Kendaraan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Data Kendaraan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Merk :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={merk} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tipe :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tipe} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Tahun :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={tahun} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Warna :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={warna} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Polisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={nopol} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>

            {/* Keterangan */}
            <Card style={{ marginTop: "20px" }}>
              <Card.Header>Keterangan</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Keterangan :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control disabled value={keterangan} />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableRegisterFidusia currentPosts={registerFidusiasPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilRegisterFidusia;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const cetakContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const cetakPage = {
  // border: "1px solid black",
  // height: "1600px",
  height: "1380px",
};

const cetakCenter = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "bold",
  fontSize: "10px",
};

const cetakTitle = {
  padding: "5px",
  textAlign: "center",
  fontSize: "10px",
};

const formulirTextFieldContainer = {
  border: "1px solid black",
  padding: "2px",
};

const textStyle = {
  marginBottom: 2,
};

const formulirTextValueContainer = {
  border: "1px solid black",
  padding: "2px",
  flex: 1,
};

const formulirDataWrapper = {
  display: "flex",
  borderTop: "1px solid black",
  paddingBottom: "0px",
  fontSize: "10px",
};

const formulirDataAlamat = {
  display: "flex",
  paddingLeft: "10px",
  paddingRight: "10px",
  fontSize: "10px",
  height: "25px",
  border: "1px solid black",
};

const textStyleHidden = {
  marginBottom: 2,
  visibility: "hidden",
};

const boxStyle = {
  border: "1px solid black",
  marginRight: "10px",
  height: "20px",
  width: "20px",
};

const spacingTop = {
  mt: 4,
};
